import { CommonHttp } from "@/models/interfaces/http/common.http.request"


export type ActiveAccessGroup = {
    Id: number
    Name: string
    CanCreateClients: boolean
    CanCreateProjects: boolean
}

export class AccessGroupsApi {
    static getGroupsOfWorker(): Promise<ActiveAccessGroup[]> {
        const http = new CommonHttp()
        return http
            .get('access/system/groups/worker')
            .then(data => data.data)
    }
}
